import React from 'react';

import Experience360 from '../../components/Experience360';
import Intro from './Intro';

import './style.scss';

const CampaignStreet = () => (
  <>
    <Experience360
      activated
      defaultLat={0}
      defaultLon={180}
      latMin={-25}
      latMax={25}
      animationSmoothing={0.15}
    />
    <Intro />
  </>
);

export default CampaignStreet;
